/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Services;
    (function (Services) {
        var SsoService = /** @class */ (function () {
            function SsoService($interval, $q, authenticationService, ssoApiService, appSettings) {
                var _this = this;
                this.$interval = $interval;
                this.$q = $q;
                this.authenticationService = authenticationService;
                this.ssoApiService = ssoApiService;
                this.appSettings = appSettings;
                this._authData = this.authenticationService.authorizationData;
                this._bufferInMinutes = 5;
                this._loadedOrganizations = false;
                this._loadedRoles = false;
                this._oneMinuteInMilliseconds = 60 * 1000;
                this._organizations = { count: 0, list: [] };
                $interval(function () { return _this.init(); }, this._oneMinuteInMilliseconds);
                this.init();
            }
            SsoService.prototype.$destroy = function () {
                if (!ap.Utilities.isNullOrUndefined(this._interval)) {
                    this.$interval.cancel(this._interval);
                }
            };
            Object.defineProperty(SsoService.prototype, "organizations", {
                get: function () { return this._organizations; },
                enumerable: true,
                configurable: true
            });
            // These are the actual role names for the system NOT claims but the role (collection of claims)
            SsoService.prototype.getActiveApplicationRoles = function (type) {
                var _this = this;
                if (this._loadedRoles) {
                    var roles = type === ApplicationRoleType.ApplicationUserRole ? this._applicationRoles : this._productRoles;
                    return this.$q.when(roles);
                }
                return this.ssoApiService.getActiveApplicationRoles().then(function (allRoles) {
                    allRoles = allRoles || [];
                    ap.Utilities.sortByProperty(allRoles, 'name');
                    _this._applicationRoles = allRoles.filter(function (x) { return x.applicationRoleType === ApplicationRoleType.ApplicationUserRole && x.isActive; });
                    _this._productRoles = allRoles.filter(function (x) { return x.applicationRoleType === ApplicationRoleType.ProductUserRole && x.isActive; });
                    if (type === ApplicationRoleType.ApplicationUserRole) {
                        return _this._applicationRoles;
                    }
                    return _this._productRoles;
                });
            };
            SsoService.prototype.loadUsersOrganizationsList = function () {
                var _this = this;
                if (this._loadedOrganizations) {
                    this.$q.when(this._loadedOrganizations);
                }
                if (ap.Utilities.isNullOrUndefined(this._orgListPromise)) {
                    this._orgListPromise = this.ssoApiService.getUsersOrganizationsList().then(function (userOrganizations) {
                        userOrganizations = userOrganizations || [];
                        ap.Utilities.sortByProperty(userOrganizations, 'name');
                        var organizations = { cacheKey: undefined, count: 0, list: [] };
                        userOrganizations.forEach(function (userOrganization) { return organizations.list.push(_this.ensureOrganizationMappings(userOrganization)); });
                        userOrganizations.forEach(function (userOrganization) { return _this.referenceOrganization(organizations, userOrganization); });
                        organizations.lastUiUpdate = Date.now();
                        ap.Utilities.extend(true, _this._organizations, organizations);
                        _this._loadedOrganizations = true;
                        return organizations;
                    }, function () { return false; });
                }
                return this._orgListPromise;
            };
            SsoService.prototype.referenceOrganization = function (organizations, organization) {
                var _this = this;
                if (ap.Utilities.isNullOrUndefined(organization) || ap.Utilities.isNullOrUndefined(organizations)) {
                    return;
                }
                ++organizations.count;
                organizations[organization.cacheKey] = organization;
                ap.Utilities.sortByProperty(organization.subOrganizationUnits, 'name');
                (organization.subOrganizationUnits || []).forEach(function (subOrganization) { return _this.referenceOrganization(organizations, subOrganization); });
            };
            SsoService.prototype.ensureOrganizationMappings = function (org) {
                var _this = this;
                if (org.hasOwnProperty('cacheKey')) {
                    return org;
                }
                var organization = {
                    cacheKey: org['CacheKey'],
                    name: org['Name'],
                    parentOrganizationUnitCacheKey: org['ParentOrganizationUnitCacheKey'],
                    subOrganizationCacheKeys: org['SubOrganizationCacheKeys'] || [],
                    subOrganizationUnits: [],
                    type: org['Type']
                };
                (org['SubOrganizationUnits'] || []).forEach(function (subOrg) {
                    var subOrganization = _this.ensureOrganizationMappings(subOrg);
                    organization.subOrganizationUnits.push(subOrganization);
                    if (ap.Utilities.isNullOrEmptyCollection(organization.subOrganizationCacheKeys.filter(function (x) { return x === organization.cacheKey; }))) {
                        organization.subOrganizationCacheKeys.push(organization.cacheKey);
                    }
                });
                return organization;
            };
            SsoService.prototype.init = function () {
                var _this = this;
                if (!this._authData.isStale(this._bufferInMinutes) && this._authData.IsManager) {
                    return;
                }
                this.renewAccessToken().then(function (updatedAuthData) {
                    if (!updatedAuthData) {
                        _this.authenticationService.logout();
                    }
                });
            };
            SsoService.prototype.getUserOrgListWithProducts = function () {
                return this.ssoApiService.getUserOrgListWithProducts();
            };
            SsoService.prototype.renewAccessToken = function () {
                return this.ssoApiService.renewAccessToken(this._authData);
            };
            SsoService.$inject = [
                '$interval',
                '$q',
                'authenticationService',
                'ssoApiService',
                'appSettings'
            ];
            return SsoService;
        }());
        Services.SsoService = SsoService;
        angular.module('app.Services')
            .service('ssoService', SsoService);
    })(Services = app.Services || (app.Services = {}));
})(app || (app = {}));
